import React, { Component } from 'react';
import _ from 'lodash';
import SendEmail from '../../components/send-email-component';
import { inject, observer } from 'mobx-react';
import Notfication from './../../utils/notification-helper';
import WorkflowStepBaseComponent from './workflow-step-base';
import moment from 'moment';
import StepActionButtons from './components/step-actions';
import StepHistory from '../../components/step-history';
import StepSendEmail from './components/step-send-email';

@inject('appStore')
@observer
export default class FileConfirmationListingGonePendingEmail extends WorkflowStepBaseComponent {
    constructor() {
        super();
        this.state = { portalEmail: null };
    }

    componentDidMount() {
        if (this.props.appStore.tcFileStore.selectedFile.isTransaction) {
            this.props.appStore.transactionStore
                .getTransactionsById(this.props.appStore.tcFileStore.selectedFile.transactionId)
                .then(({ transaction }) => {
                    this.setState({ portalEmail: { email: transaction.PortalEmail, name: 'Property' } });
                })
                .catch(() => {
                    Notfication.ToastError('Step failed to load');
                });
        } else {
            Notfication.ToastError('Step failed to load (expected file to be for a transaction)');
        }
    }

    onSent(emailModel) {
        const step = this.props.step;

        step.state.isComplete = true;
        step.state.data.model = emailModel;
        step.state.data.portalEmail = this.state.portalEmail;
        step.state.data.sentDate = moment().format();

        return this.updateStepState(step);
    }

    renderCompleteView(step) {
        return (
            <div>
                <StepSendEmail
                    model={step.state.data.model}
                    step={this.props.step}
                    sentDate={step.state.data.sentDate}
                />
                <div className={'col-md-12'}>
                    <StepHistory
                        transitions={this.props.step.state.transitions ? this.props.step.state.transitions : []}
                        emails={this.props.step.state.data.emails ? this.props.step.state.data.emails : []}
                    />
                </div>
            </div>
        );
    }

    renderIncompleteView() {
        const agent = _.clone(this.props.appStore.tcFileStore.selectedFile.agent),
            isNA = this.props.step.state.isMarkedNotApplicable;

        return (
            <div>
                <StepActionButtons viewStore={this.viewStore} step={this.props.step} />
                {isNA ? null : <hr className="section-header" />}
                {!_.isEmpty(this.state.portalEmail) ? (
                    <StepSendEmail
                        step={this.props.step}
                        updateStepState={this.updateStepState.bind(this)}
                        typeOfSale={this.props.appStore.tcFileStore.selectedFile.typeOfSale}
                        toEmails={[agent.emailContact]}
                        ccEmails={[this.state.portalEmail]}
                        template={'confirmation-sale'}
                        extraTemplateData={{ agent }}
                        isHidden={isNA}
                        onSent={this.onSent.bind(this)}
                        hasCancelHandler={this.props.hasCancelHandler}
                    />
                ) : (
                    <span>loading.....</span>
                )}
                <div className={'col-md-12'}>
                    <StepHistory
                        transitions={this.props.step.state.transitions ? this.props.step.state.transitions : []}
                        emails={this.props.step.state.data.emails ? this.props.step.state.data.emails : []}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/file-confirmation-sale.js